import React from 'react';

import * as userAdminService from '../../../services/user/admin/User';

const UserAdminContext = React.createContext();
const { Provider, Consumer } = UserAdminContext;

class UserAdminProvider extends React.Component {
  state = {
    response: null,
  };

  constructor(props) {
    super(props);
    this.home = this.home.bind(this);
    this.addUser = this.addUser.bind(this);
    this.editUser = this.editUser.bind(this);
    this.updateUser = this.updateUser.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
  }

  async home(data) {
    return new Promise(async (resolve, reject) => {
      await userAdminService
        .home(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async addUser(data) {
    return new Promise(async (resolve, reject) => {
      await userAdminService
        .addUser(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async editUser(id) {
    return new Promise(async (resolve, reject) => {
      await userAdminService
        .editUser(id)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async updateUser(data) {
    return new Promise(async (resolve, reject) => {
      await userAdminService
        .updateUser(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async deleteUser(data) {
    return new Promise(async (resolve, reject) => {
      await userAdminService
        .deleteUser(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  render() {
    const { children } = this.props;

    return (
      <Provider
        value={{
          response: this.state.response,
          home: this.home,
          addUser: this.addUser,
          editUser: this.editUser,
          updateUser: this.updateUser,
          deleteUser: this.deleteUser,
        }}
      >
        {children}
      </Provider>
    );
  }
}

export default UserAdminContext;

export { UserAdminProvider, Consumer };
